import {VictoryPointDataController} from './VictoryPointDataController.ts'
import {EnumUtils} from '@colonist/utils'
import {type BaseVictoryPointData} from './BaseVictoryPointData.ts'
import {VictoryPointTypes} from './VictoryPoints.ts'
import {type NestedReadonly, type VictoryPointState} from '@colonist/game-states'

export class VictoryPointStateReader {
    static totalPublicVictoryPoints(state: NestedReadonly<VictoryPointState>): number {
        let publicVictoryPointsSum = 0
        for(const victoryPointType of Object.keys(state)) {
            const victoryPointData = VictoryPointDataController.getVictoryPointByType(Number(victoryPointType))
            if(victoryPointData == undefined) continue
            if(victoryPointData.private) continue
            publicVictoryPointsSum += (victoryPointData.value * state[victoryPointType])
        }
        return publicVictoryPointsSum
    }

    static totalPrivateVictoryPoints(state: NestedReadonly<VictoryPointState>): number {
        let privateVictoryPoints = 0
        for(const victoryPointType of Object.keys(state)) {
            const victoryPointData = VictoryPointDataController.getVictoryPointByType(Number(victoryPointType))
            if(victoryPointData == undefined) continue
            privateVictoryPoints += (victoryPointData.value * state[victoryPointType])
        }
        return privateVictoryPoints
    }

    static totalVictoryPointsOfType(state: NestedReadonly<VictoryPointState>, victoryPointTypes: VictoryPointTypes[]): number {
        let totalVictoryPoints = 0
        for(const type of victoryPointTypes) {
            if(state[type] == undefined) continue

            const victoryPointData = VictoryPointDataController.getVictoryPointByType(type)
            if(victoryPointData == undefined) continue

            totalVictoryPoints += (state[type] ?? 0) * victoryPointData.value
        }
        return totalVictoryPoints
    }

    static getAllUniqueVictoryPointTypesEarned(state: NestedReadonly<VictoryPointState>): VictoryPointTypes[] {
        const uniqueTypes: VictoryPointTypes[] = []
        EnumUtils.iterateEnum(VictoryPointTypes, (victoryPointType) => {
            if(state[victoryPointType] != undefined) uniqueTypes.push(victoryPointType)
        })
        return uniqueTypes
    }
}

export class VictoryPointStateWriter {
    static addVictoryPoint(state: VictoryPointState, victoryPoint: BaseVictoryPointData): void {
        if(state[victoryPoint.victoryPointType] == undefined) state[victoryPoint.victoryPointType] = 0
        state[victoryPoint.victoryPointType] = (state[victoryPoint.victoryPointType] ?? 0) + 1
    }

    static removeVictoryPoint(state: VictoryPointState, victoryPointType: VictoryPointTypes): boolean {
        if(state[victoryPointType] == undefined) return false
        state[victoryPointType] = (state[victoryPointType] ?? 0) - 1
        return true
    }
}
